import { ReactNode } from 'react';

import ReportSidebar from './report-side-bar';
import DashboardContainer from '../dashboard-layout/dashboard-container';
import { DASHBOARD_CONFIG } from '../common/constants';

interface IReportLayoutType {
  children: ReactNode;
}

const ReportLayout = ({ children }: IReportLayoutType) => {
  return (
    <>
      <ReportSidebar />
      <DashboardContainer variant="sm" sx={{ ml: DASHBOARD_CONFIG.NAVIGATION.DESKTOP_WIDTH / 8 }}>
        {children}
      </DashboardContainer>
    </>
  );
};

export default ReportLayout;
